<template>
    <div class="bg-gray-200 p-4">
      <h2 class="font-bold text-lg mb-4">Categorías</h2>
      <ul>
        <li v-for="(category, index) in categories" :key="index" class="mb-2">
          <span v-if="category.subcategories" @click="category.expanded = !category.expanded" class="cursor-pointer">
            {{ category.name }}
            <span v-if="category.expanded">▼</span>
            <span v-else>►</span>
          </span>
          <span v-else>{{ category.name }}</span>
          <ul v-if="category.subcategories && category.expanded" class="ml-4">
            <li v-for="(subcategory, subIndex) in category.subcategories" :key="subIndex">
              {{ subcategory }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        categories: [
          { name: 'Refrigeración' },
          { 
            name: 'Lavadoras', 
            expanded: false, 
            subcategories: ['Motores lavado', 'Motores exprimido', 'Suspensión'] 
          },
          { name: 'Cocina' },
          // ... más categorías
        ]
      };
    }
  };
  </script>